/**
 * @ngdoc directive
 * @name flowLibrary
 * @module flowingly.runner.library
 * @usage
 * ```
      <flow-library></flow-library>
 * ``` 
 */

import angular from 'angular';

angular.module('flowingly.runner.library').component('flowLibrary', {
  templateUrl: 'Client/runner.library/runner.library.tmpl.html'
});
